<div class="overview-content-wrapper" markantPlatformScrollIndicator>
  <div class="service-info">
    <h4 class="headline">{{ 'booking.overview.cartridge' | transloco }}</h4>
    <span>{{ bookingData.variant.name }}</span>
  </div>
  <div class="split-pane">
    <div class="child-pane price-details">
      <h4 class="headline cost-listing-headline">
        {{ 'cartridge.costListing' | transloco }}
      </h4>
      <div class="price-info">
        <ng-container *ngIf="!isBulkPrice">
          <div>
            <h4 class="headline">
              {{ 'booking.overview.priceModel' | transloco }}
            </h4>
            <span
              >{{ 'cartridge.priceModel.' + price.priceModel | transloco }}
              {{
                'cartridge.billingPeriod.' + price.billingPeriod | transloco
              }}</span
            >
          </div>
          <div>
            <h4 class="headline">{{ 'booking.overview.price' | transloco }}</h4>
            <span>{{
              price.centAmount / 100
                | translocoCurrency: 'symbol' : {} : price.currency
            }}</span
            >&nbsp;<span class="vat-info">{{
              'cartridge.priceExcludingVAT' | transloco
            }}</span>
          </div>
        </ng-container>
        <div *ngIf="isBulkPrice">
          <markant-platform-price-scale
            [price]="price"
            [servicePackage]="bookingData.cartridge.cartridgeServicePackages"
          >
          </markant-platform-price-scale>
        </div>
        <div *ngIf="setUpCost" class="setup-costs-info">
          <h6 class="headline">{{ 'cartridge.plusSetUpCosts' | transloco }}</h6>
          <span>{{
            setUpCost.centAmount / 100
              | translocoCurrency: 'symbol' : {} : setUpCost.currency
          }}</span
          >&nbsp;<span class="vat-info">{{
            'cartridge.priceExcludingVAT' | transloco
          }}</span>
        </div>
      </div>
      <markant-expansion-panel
        *ngIf="
          bookingData.variant.calculationParameters &&
          bookingData.variant.calculationParameters.length
        "
        class="calculation-parameters-info"
      >
        <markant-expansion-panel-item
          class="calculation-parameters-wrapper"
          colorMode="custom"
        >
          <div slot="header">
            <h5 class="calculation-parameters-headline">
              {{ 'booking.overview.calculationParameters' | transloco }}
            </h5>
          </div>
          <div slot="content" class="calculation-parameters-content">
            <ul class="calculation-parameter-list">
              <li
                *ngFor="
                  let calculationParameter of bookingData.variant
                    .calculationParameters
                "
                class="calculation-parameter-item"
              >
                {{ calculationParameter }}
              </li>
            </ul>
          </div>
        </markant-expansion-panel-item>
      </markant-expansion-panel>
    </div>
    <markant-seperator
      class="separator"
      orientation="vertical"
    ></markant-seperator>
    <div class="child-pane booking-details">
      <div>
        <h4 class="headline">
          {{ 'booking.overview.contractualParty' | transloco }}
        </h4>
        <dl class="contact-list">
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.name' | transloco }}:
            </dt>
            <dd class="contact-value">{{ bookingData.organization.name }}</dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.street' | transloco }}:
            </dt>
            <dd class="contact-value">
              {{ bookingData.organization.address.street }}
              {{ bookingData.organization.address.streetNumber }}
            </dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.city' | transloco }}:
            </dt>
            <dd class="contact-value">
              {{ bookingData.organization.address.zipCode }}
              {{ bookingData.organization.address.city }}
            </dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.country' | transloco }}:
            </dt>
            <dd class="contact-value">{{ localizedCountryName | async }}</dd>
          </div>
        </dl>
      </div>
      <div>
        <h4 class="headline">
          {{ 'booking.form.headline.billingContact' | transloco }}
        </h4>
        <dl class="contact-list">
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.name' | transloco }}:
            </dt>
            <dd class="contact-value">
              {{
                'general.salutation.' + bookingData.user.salutation | transloco
              }}
              {{ bookingData.user.firstname }} {{ bookingData.user.lastname }}
            </dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.email' | transloco }}:
            </dt>
            <dd class="contact-value">{{ bookingData.user.email }}</dd>
          </div>
          <div *ngIf="bookingData.user.position" class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.position' | transloco }}:
            </dt>
            <dd class="contact-value">{{ bookingData.user.position }}</dd>
          </div>
          <div *ngIf="bookingData.user.phone" class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.phone' | transloco }}:
            </dt>
            <dd class="contact-value">{{ bookingData.user.phone }}</dd>
          </div>
        </dl>
      </div>
      <div>
        <h4 class="headline">
          {{ 'booking.form.headline.billingAddress' | transloco }}
        </h4>
        <dl class="contact-list">
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.name' | transloco }}:
            </dt>
            <dd class="contact-value">{{ bookingData.organization.name }}</dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.street' | transloco }}:
            </dt>
            <dd class="contact-value">
              {{ bookingData.organization.address.street }}
              {{ bookingData.organization.address.streetNumber }}
            </dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.city' | transloco }}:
            </dt>
            <dd class="contact-value">
              {{ bookingData.organization.address.zipCode }}
              {{ bookingData.organization.address.city }}
            </dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.country' | transloco }}:
            </dt>
            <dd class="contact-value">{{ localizedCountryName | async }}</dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{ 'booking.overview.contactInformation.email' | transloco }}:
            </dt>
            <dd class="contact-value">
              {{
                bookingData.organization.billingEmail?.length
                  ? bookingData.organization.billingEmail
                  : bookingData.billingEmail
              }}
            </dd>
          </div>
          <div class="contact-row">
            <dt class="contact-term">
              {{
                'booking.overview.contactInformation.billingLanguage'
                  | transloco
              }}:
            </dt>
            <dd class="contact-value">
              {{
                'languageSelect.' +
                  (bookingData.organization.billingLanguageIsoCode?.length
                    ? (bookingData.organization.billingLanguageIsoCode
                      | lowercase)
                    : (bookingData.billingLanguageIsoCode
                      | defaultValue
                      | lowercase)) | transloco
              }}
            </dd>
          </div>
        </dl>
      </div>
      <div
        *ngIf="
          bookingData.references
            ?.customerCartridgeReferenceId as customerCartridgeReferenceId
        "
      >
        <h4 class="headline">
          {{ 'booking.form.formFields.customerReference' | transloco }}
        </h4>
        <span>{{ customerCartridgeReferenceId }}</span>
      </div>
      <div *ngIf="bookingData.references?.costCenter as costCenter">
        <h4 class="headline">
          {{ 'booking.form.formFields.costCentre' | transloco }}
        </h4>
        <span>{{ costCenter }}</span>
      </div>
      <div *ngIf="bookingData.references?.otherReferences as otherReferences">
        <h4 class="headline">
          {{ 'booking.form.formFields.reference' | transloco }}
        </h4>
        <span>{{ otherReferences }}</span>
      </div>
      <div>
        @if (bookingData.priceRequest) {
          <section class="legal-paragraph price-request-paragraph">
            <ui-booking-offer-link
              [offerNumber]="bookingData.priceRequest.offerNumber"
              (offerLinkClicked)="
                openOfferDocument(bookingData.priceRequest.id)
              "
            ></ui-booking-offer-link>
          </section>
        }

        <p
          class="legal-paragraph"
          [innerHTML]="'booking.overview.legal.text' | transloco"
        ></p>

        <div class="legal-confirmation">
          <markant-checkbox
            data-cy="legal-confirmation-checkbox"
            #legalCheckbox
            class="legal-confirmation-checkbox"
            (checkedChange)="changeServiceGTCAccepted($event)"
          ></markant-checkbox>
          <div
            [innerHTML]="
              'booking.overview.legal.confirmation'
                | transloco
                  : {
                      linkTextServiceConditions:
                        '<a class=legal-notice-link>' +
                        ('booking.overview.legal.linkTextServiceConditions'
                          | transloco) +
                        '</a>',
                      linkTextServiceGTCs:
                        '<a class=service-gtc-link>' +
                        ('booking.overview.legal.linkTextServiceGTCs'
                          | transloco) +
                        '</a>',
                    }
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="button-row">
  <markant-button
    data-cy="order-request-back-button"
    colorScheme="primary"
    (click)="goBack.emit()"
    variant="clear"
  >
    <markant-icon icon="m_arrow-left" slot="icon-leading" class="button-icon">
    </markant-icon>
    <span class="next-text">{{ 'general.back' | transloco }}</span>
  </markant-button>

  <markant-button
    data-cy="order-request-confirm-button"
    class="next-button"
    colorScheme="primary"
    [loading]="isLoading"
    [disabled]="!legalCheckbox.checked"
    (click)="triggerNext()"
  >
    <span class="next-text">{{ 'booking.overview.confirm' | transloco }}</span>
  </markant-button>
</div>
